import { render, staticRenderFns } from "./PayRate.vue?vue&type=template&id=a8a4b828"
import script from "./PayRate.vue?vue&type=script&lang=js"
export * from "./PayRate.vue?vue&type=script&lang=js"
import style0 from "./PayRate.vue?vue&type=style&index=0&id=a8a4b828&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports